module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_05-b55dba6a75fca2f982ccaaecedfa4542.svg";